module.exports = __webpack_public_path__ + "17f93b5b.png";